import { render } from "./user_info.vue?vue&type=template&id=736cd602&lang=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__